<template>
  <q-tooltip
    :delay="550"
    class="bg-transparent"
    :offset="[0, 0]"
  >
    <q-markup-table
      separator="cell"
      bordered
      flat
      dense
      class="bg-grey-2 text-grey-9"
    >
      <tbody>
        <tr>
          <td class="text-bold">
            Site
          </td>
          <td :class="{ 'text-bold': formattedDateComponent.timezoneMode.value === TIMEZONE_MODES.SITE }">
            {{ $d(formattedDateComponent.siteTimeValue, 'long') }} ({{ formattedDateComponent.currentSite.timeZone }})
          </td>
        </tr>
        <tr v-if="formattedDateComponent.shouldShowTimezoneControls">
          <td class="text-bold">
            Local
          </td>
          <td :class="{ 'text-bold': formattedDateComponent.timezoneMode.value === TIMEZONE_MODES.LOCAL }">
            {{ $d(formattedDateComponent.localTimeValue, 'long') }} ({{ systemTimeZoneName }})
          </td>
        </tr>
        <tr>
          <td class="text-bold">
            Relative
          </td>
          <td :class="{ 'text-bold': formattedDateComponent.timezoneMode.value === TIMEZONE_MODES.RELATIVE }">
            {{ formattedDateComponent.localTimeValue.relativeTime() }}
          </td>
        </tr>
      </tbody>
    </q-markup-table>
  </q-tooltip>
</template>

<script>

const systemTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone
import { TIMEZONE_MODES } from 'src/models/Model'

export default {
  name: 'FormattedDateTooltip',
  props: {
    formattedDateComponent: {
      type: Object,
      required: true
    }
  },
  created () {
    _.extend(this, {
      systemTimeZoneName,
      TIMEZONE_MODES
    })
  }
}

</script>
